/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable object-shorthand */
// delayedLoad causes a state change which runs a conditional that can not be executed another way

// Error Warning on invalid search
import React, {
  useState, useEffect, useRef, useCallback,
} from 'react';
import ReactDOM from 'react-dom';
import i18n from 'i18next';
import { Translation } from 'react-i18next';
import axios from 'axios';
import GoogleMapReact from 'google-map-react';
import PropTypes from 'prop-types';
import Marker from '../marker/marker.jsx';
import CurrentPositionMarker from '../currentPositionMarker/currentPositionMarker.jsx';
import LocationInfoWindow from '../infowindow/infowindow.jsx';
import CtaBlock from '../ctablock/ctablock.jsx';
import MobileDetect from '../mobile/mobiledetect.jsx';
import './map.scss';

// https://stackoverflow.com/questions/54150783/react-hooks-usestate-with-object
// Olamigoke Philip
// https://medium.com/swlh/how-to-usestate-react-hooks-476794132bd0
// https://react-hooks-cheatsheet.com/usestate

// https://stackoverflow.com/questions/44712753/what-is-a-suitable-wai-aria-role-attribute-for-a-map-element
// Dan Alboteanu

// In the previous version of locationfinder the infoWindow component was set with a state.
// Given that it used the same variable as several other states it was merged into selectedLocationId.

// However the display behavior itself still has to be managed.
// This should not be a state because another state change will trigger rerenders when appropriate.
// For this to work properly it has to be placed outside the component.
// used with toggleDisplayInfoWindow

// There may be a better way to do this, but not every state tracking variable in react needs to trigger a render cycle
// or perhaps useEffect use needs to be improved
// User interaction toggle variable
let displayInfoWindow = false;

// Stores polygons for google maps
// Does not need to be a state, but polygons must be stored outside of repeating code
const polygons = [];

// Used with props.config.searchOnLoad and props.config.initialSearchThreshold to make sure these behaviors only execute on the first api call
let initApiCallExecuted = false;

// United States: Prescott, Arizona
// At certain zoom levels this provides a roughly centered map of the US
// Lebanon, Kansas is the center of the continguous 48, not sure why it works this way.

// Google Map default variable
const mapDefaults = {
  latitude: 35,
  longitude: -113,
  zoom: 4,
};

const Map = (props) => {
  if (!initApiCallExecuted) {
    navigator.geolocation.getCurrentPosition((position) => {
      mapDefaults.latitude = parseFloat(position.coords.latitude) || 35;
      mapDefaults.longitude = parseFloat(position.coords.longitude) || -113;
    });
  }

  // Component States
  const [centerPosition, setCenterPosition] = useState({ centerLatitude: mapDefaults.latitude, centerLongitude: mapDefaults.longitude });
  const [delayedLoad, setDelayedLoad] = useState(false);
  const [distanceFilter, setDistanceFilter] = useState('');
  const [locations, setLocations] = useState([]);
  const [displayedLocations, setDisplayedLocations] = useState([]);
  const [locationMarkers, setLocationMarkers] = useState();
  const [locationStatus, setLocationStatus] = useState('');
  const [mapZoom, setMapZoom] = useState(mapDefaults.zoom);
  const [matchesFilterCount, setMatchesFilterCount] = useState(false);
  const [status, setStatus] = useState({ error: false, loading: false });
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const [servicesFilters, setServicesFilters] = useState(props.config.servicesFilters || []);
  const [userLocation, setUserLocation] = useState({ userLocationString: '', userLatitude: null, userLongitude: null });
  const [serviceAreas, setServiceAreas] = useState({});

  // Google Map Variables
  const googleApiKey = window.sbGlobals.googleApiKey;

  // Element variables
  const mobileDetect = <MobileDetect/>;
  let DisplayMap;
  let LoadingMap;
  let UserLocationMarker;

  // Toggle variables
  let userInteractionToggle = false;

  // Refs used by Google Map
  const mapRef = useRef();
  const mapsRef = useRef();
  const infoWindowRef = useRef();

  // Infowindow display control function used by map->ctaBlock->locations->location and on marker clicks
  // display infowindow, userInteractionToggle turns off infowindow on search
  const toggleDisplayInfoWindow = () => {
    if (mobileDetect.props.getBreakpoint() !== 'sm') {
      // does not run on mobile
      displayInfoWindow = true;
      userInteractionToggle = true;
      if (infoWindowRef.current && !infoWindowRef.current.isOpen) {
        infoWindowRef.current.open(mapRef.current);
      }
    }
  };

  // Callback used to set map refs
  const onMapLoad = useCallback((map, maps) => {
    mapRef.current = map;
    mapsRef.current = maps;
  }, []);

  const panToCenter = () => {
    const sbMapBounds = document.querySelector('.sb-map-bounds');
    const style = window.getComputedStyle(sbMapBounds);
    // Default value prevents undefined errors
    const paddingRight = parseFloat(style.paddingRight);
    const paddingLeft = parseFloat(style.paddingLeft);
    // Determines whether alignment is + or -
    // /2 Center pin by splitting the difference
    mapRef.current.panBy((paddingRight - paddingLeft) / 2, 0);
  };

  // Manage Google Map infoWindow
  const createInfoWindow = (location) => {
    /*
    infowindow is targeted using id=infoWindow but we still want
    react component so we render it into this id
    */
    if (infoWindowRef.current) {
      infoWindowRef.current.setPosition({
        lat: parseFloat(location.lat),
        lng: parseFloat(location.lon),
      });
      const infoWindowId = `infoWindow-${props.config.mapId}`;
      infoWindowRef.current.addListener('domready', () => {
        ReactDOM.render(<LocationInfoWindow location={location} template={props.config.customTemplates['location-infowindow']} />, document.getElementById(infoWindowId));
        /*
        Ideally element changes should be tracked by a state in a component
        Because the DOM change is being implemented via jquery/javascript this isn't possible.

        Google Map isn't aware of the DOM change.
        This creates an issue where the map must be recentered manually.

        The next best option would be a resize observer
        https://developer.mozilla.org/en-US/docs/Web/API/Resize_Observer_API
        - Not a resize event, those only apply to the document/body/window level
        - Unfortunantely the Resize_Observer_API is beyond the support threshold of locationfinder (Edge 79).

        Therefore a click event must be used which creates a potential race condition.
        Ideally the click event captures the starting height of the infowindow before the interval
        and the interval lasts long to fire after the change, but is not so long as to frustrate the user

        infoWindowRef.current.open(mapRef.current) does work successfully on the first pin opened
        but will not worker for properly on successive pin.
        */

        document.getElementById(infoWindowId).onclick = (e) => {
          if (e.target.classList.contains('sb-infowindow-resize')
            || e.target.parentNode.classList.contains('sb-infowindow-resize')) {
            // Finds center and properly centers default infoWindow on Y-axis
            // Offset is not implemented.
            mapRef.current.setCenter(infoWindowRef.current.getPosition());
            // Pan on X axis according to padding
            panToCenter();
            const startingHeight = document.getElementById(infoWindowId).offsetHeight; 
            setTimeout(() => {
              const endingHeight = document.getElementById(`infoWindow-${props.config.mapId}`).offsetHeight;
              // -25 is the default offset from the top
              if (startingHeight < endingHeight) {
                // Hopefully the size change is properly captured
                mapRef.current.panBy(0, startingHeight - endingHeight - 25);
              } else {
                mapRef.current.panBy(0, -25);
              }
            }, '250');
          }
        };
      });
      // https://stackoverflow.com/questions/67873546/trying-to-implement-shouldfocus-infowindowopen-option-in-google-maps-api
      // In the future perhaps shouldFocus: false should be set, because navigating googlemap is awkward even with changes.
      infoWindowRef.current.open(mapRef.current);
    }
  };

  // Start up function that sets value of userLocation state object.
  // Set via config object passed from backend or browsers geolocation tools.
  // Set error status if neither of these options are possible.
  const setStartingLocation = () => {
    const options = {
      enableHighAccuracy: false,
      maximumAge: 60000,
      timeout: 7000,
    };
    // If present use nearLocation passed by config object to set Google Map to start.
    if (props.config.nearLocation) {
      setLocationStatus('manual');
      if (props.config.nearLocation != userLocation.userLocationString) {
        setUserLocation({
          userLocationString: props.config.nearLocation,
          userLatitude: null,
          userLongitude: null,
        });
      }
    } else if (!props.config.disableGeolocation) {
      // If nearLocation is not present and geolocation is not disabled by client attempt to use navigator to set map
      if (!navigator.geolocation.getCurrentPosition && typeof navigator.geolocation.getCurrentPosition !== 'function') {
        // This navigator.geolocation.getCurrentPosition has enjoyed broad support form many years and this code is likely not necessary.
        // However I am uncertain how browser side geolocation blocking works, it may disable this function.
        if (props.config.defaultLocation && props.config.searchOnLoad) {
          // This logic might be used as a fallback
          setLocationStatus('manual');
          setUserLocation({
            userLocationString: '',
            userLatitude: props.config.defaultLocation.lat,
            userLongitude: props.config.defaultLocation.lon,
          });
        } else {
          setLocationStatus('error');
        }
      }
      // this function get triggered by browser tab changes even though it appears the useEffect enclosure that calls code runs only once
      // initApiCallExecuted prevents this from triggering unnecessarily
      if (!initApiCallExecuted) {
        return navigator.geolocation.getCurrentPosition(((position) => {
          if (parseFloat(position.coords.latitude) != userLocation.userLatitude) {
            setUserLocation({
              userLocationString: '',
              userLatitude: parseFloat(position.coords.latitude),
              userLongitude: parseFloat(position.coords.longitude),
            });
          }
        }), () => {
          if (props.config.defaultLocation && props.config.searchOnLoad) {
            // This logic might be used as a fallback
            setLocationStatus('manual');
            setUserLocation({
              userLocationString: '',
              userLatitude: props.config.defaultLocation.lat,
              userLongitude: props.config.defaultLocation.lon,
            });
          } else {
            setLocationStatus('error');
          }
        }, options);
      }
    } else if (props.config.defaultLocation && props.config.searchOnLoad) {
      setLocationStatus('manual');
      setUserLocation({
        userLocationString: '',
        userLatitude: props.config.defaultLocation.lat,
        userLongitude: props.config.defaultLocation.lon,
      });
    } else {
      // No set nearLocation and geolocation disabled
      setLocationStatus('error');
    }
    return false;
  };

  // Determines what locations are rendered in CTA block
  // Triggers during the initialization process, on drag and on zoom in and out.
  // Care only about map bounds and will ignore if map is hidden under DOM elements.
  // Markers are rendered regardless.
  const filterLocations = () => {
    if (locations.length && mapRef.current) {
      const bounds = mapRef.current.getBounds();
      // bounds object returns consistent information but the keys on the object may be different
      // they can not be accessed directly and getSouthWest/getNorthEast function must be used
      const northEastLat = bounds.getNorthEast().lat();
      const northEastLon = bounds.getNorthEast().lng();
      const southWestLat = bounds.getSouthWest().lat();
      const southWestLon = bounds.getSouthWest().lng();

      const filteredLocations = [];
      // Iterative for loops are the fastest way to perform a variety of operations in Javascript
      for (let i = 0; i < locations.length; i++) {
        if (
          ((parseFloat(locations[i].lon) > southWestLon || (parseFloat(locations[i].lon) < 0 && southWestLon > 0)) && parseFloat(locations[i].lon) < northEastLon)
          && (parseFloat(locations[i].lat) > southWestLat && parseFloat(locations[i].lat) < northEastLat)
        ) {
          filteredLocations.push(locations[i]);
        }
      }
      setDisplayedLocations(filteredLocations);
    }
  };

  const setMapBounds = (bounds) => {
    // Bounding box used by google maps.
    // Padding params from a hidden html element are used to set bounds.
    // This design decision was made because it is a way for front end web devs to easily edit the bounds with css.
    // They don't have direct access to this javascript and no backend code needs to be added to support this form of editing.
    const sbMapBounds = document.querySelector('.sb-map-bounds');
    const style = window.getComputedStyle(sbMapBounds);
    const paddingTop = parseFloat(style.paddingTop);
    const paddingRight = parseFloat(style.paddingRight);
    const paddingBottom = parseFloat(style.paddingBottom);
    const paddingLeft = parseFloat(style.paddingLeft);
    mapRef.current.fitBounds(bounds, {
      top: paddingTop, right: paddingRight, bottom: paddingBottom, left: paddingLeft,
    });
  };

  const generateBoundingBox = (bounds, centerLatitude, centerLongitude, inBoundsLocations) => {
    // padding to prevent default tight zoom for zero or one location results
    let radius = 5;

    if (inBoundsLocations.length === 1) {
      radius = inBoundsLocations[0].distance + 2.5;
    }

    // NW
    bounds.extend(new mapsRef.current.LatLng(
      centerLatitude + (radius / 68.96139),
      centerLongitude - (radius / 55.11761),
    ));
    // NE
    bounds.extend(new mapsRef.current.LatLng(
      centerLatitude + (radius / 68.96139),
      centerLongitude + (radius / 55.11761),
    ));
    // SW
    bounds.extend(new mapsRef.current.LatLng(
      centerLatitude - (radius / 68.96139),
      centerLongitude - (radius / 55.11761),
    ));
    // SE
    bounds.extend(new mapsRef.current.LatLng(
      centerLatitude - (radius / 68.96139),
      centerLongitude + (radius / 55.11761),
    ));
  };

  const locationsInBounds = (centerLatitude, centerLongitude, locationsList) => {
    // Display locations within bounds set by user
    // Length of 1° latitude~68.96139 miles
    // Length of 1° longitude~55.11761 miles
    // Use distanceUnits/kilometers
    // Convert km to mi 0.621371
    let radius;
    if (parseFloat(props.config.initialSearchThreshold) && !initApiCallExecuted) {
      radius = parseFloat(props.config.initialSearchThreshold);
    } else if (props.config.threshold) {
      radius = parseFloat(props.config.threshold);
    } else {
      radius = 2000;
    }
    if (props.config.distanceUnit === 'km') {
      radius /= 0.621371;
    }

    const inBoundsLocations = [];
    // Iterative for loops are more performative than defined methods
    for (let i = 0; i <= locationsList.length - 1; i++) {
      if (
        (parseFloat(locationsList[i].lat) > centerLatitude - (radius / 68.96139) && parseFloat(locationsList[i].lat) < centerLatitude + (radius / 68.96139))
        && (parseFloat(locationsList[i].lon) > centerLongitude - (radius / 55.11761) && parseFloat(locationsList[i].lon) < centerLongitude + (radius / 55.11761))
      ) {
        inBoundsLocations.push(locationsList[i]);
      }
    }
    return inBoundsLocations;
  };

  const addLocationsToBounds = (inBoundsLocations, bounds, centerLatitude, centerLongitude) => {
    // limit takes priority over threshold
    // if no limit or fewer locations than limit
    const limit = props.config.limit || 20;

    if (inBoundsLocations.length <= limit) {
      // Iterative for loops are more performative than defined methods
      inBoundsLocations.forEach((location) => {
        bounds.extend(new mapsRef.current.LatLng(
          parseFloat(location.lat),
          parseFloat(location.lon),
        ));
      });
    } else {
      // Use pythagorean theorem (a squared + b squared = c squared) to compare distance from center
      // lowest first
      const sortedLocations = inBoundsLocations.sort((first, second) => {
        const firstDistance = ((centerLatitude - parseFloat(first.lat)) ** 2) + ((centerLongitude - parseFloat(first.lon)) ** 2);
        const secondDistance = ((centerLongitude - parseFloat(second.lat)) ** 2) + ((centerLongitude - parseFloat(second.lon)) ** 2);
        return secondDistance - firstDistance;
      });
      sortedLocations.slice(0, limit).forEach((location) => {
        bounds.extend(new mapsRef.current.LatLng(
          parseFloat(location.lat),
          parseFloat(location.lon),
        ));
      });
    }
    if (props.config.infoWindowOnSearch && !userInteractionToggle && !selectedLocationId) {
      createInfoWindow(inBoundsLocations[0]);
    }
  };

  /* Replaces GoogleMapReact center attribute */
  const centerMap = () => {
    mapRef.current.setCenter({
      lat: parseFloat(centerPosition.centerLatitude),
      lng: parseFloat(centerPosition.centerLongitude),
    });
    panToCenter();
  };

  const handleAutoZoom = (locationsList, geocoordinates) => {
    // The following lines, and accompanying conditional, allow for a scenario where:
    // > The map is displayed on desktop but NOT on mobile devices and it is desired that the location list should still display
    // This behavior is toggled with the custom css property --map-view-hidden
    const element = document.getElementById('Google-Map-Container');
    const styles = window.getComputedStyle(element);
    const isMapViewHidden = styles.getPropertyValue('--map-view-hidden');
    // handleAutoZoom called by multiple functions
    // Geocoordinates provides new lat & lon from axios search
    if (locationsList.length >= 1 && mapsRef.current && !isMapViewHidden) {
      const bounds = new mapsRef.current.LatLngBounds();
      let locationsInFrame = false;
      if (geocoordinates) {
        const parsedLatitude = parseFloat(geocoordinates.lat);
        const parsedLongitude = parseFloat(geocoordinates.lon);
        bounds.extend(new mapsRef.current.LatLng(
          parsedLatitude,
          parsedLongitude,
        ));
        const inBoundsLocations = locationsInBounds(parsedLatitude, parsedLongitude, locationsList);
        if (inBoundsLocations.length > 0) {
          locationsInFrame = true;
          addLocationsToBounds(inBoundsLocations, bounds, parsedLatitude, parsedLongitude);
        }
        if (inBoundsLocations.length <= 1) {
          generateBoundingBox(bounds, parsedLatitude, parsedLongitude, inBoundsLocations);
        }
      } else if (userLocation.userLatitude && userLocation.userLongitude) {
        bounds.extend(new mapsRef.current.LatLng(
          userLocation.userLatitude,
          userLocation.userLongitude,
        ));
        // extend bounds to if userLocation is present
        const inBoundsLocations = locationsInBounds(parseFloat(userLocation.userLatitude), parseFloat(userLocation.userLongitude), locationsList);
        if (inBoundsLocations.length > 0) {
          locationsInFrame = true;
          addLocationsToBounds(inBoundsLocations, bounds, parseFloat(userLocation.userLatitude), parseFloat(userLocation.userLongitude));
        }
        if (inBoundsLocations.length <= 1) {
          generateBoundingBox(bounds, parseFloat(userLocation.userLatitude), parseFloat(userLocation.userLongitude), inBoundsLocations);
        }
      } else {
        bounds.extend(new mapsRef.current.LatLng(
          centerPosition.centerLatitude,
          centerPosition.centerLongitude,
        ));
        const inBoundsLocations = locationsInBounds(centerPosition.centerLatitude, centerPosition.centerLongitude, locationsList);
        if (inBoundsLocations.length > 0) {
          locationsInFrame = true;
          addLocationsToBounds(inBoundsLocations, bounds, centerPosition.centerLatitude, centerPosition.centerLongitude);
        }
        if (inBoundsLocations.length <= 1) {
          generateBoundingBox(bounds, centerPosition.centerLatitude, centerPosition.centerLongitude, inBoundsLocations);
        }
      }
      setMapBounds(bounds);
    } else if (isMapViewHidden) {
      setDisplayedLocations(locationsList.slice(0, 20));
    } else {
      // single result
      //
      // set a map zoom level since we are not fitting to bounds
      setMapZoom(9);
      if (geocoordinates && mapRef.current) {
        // probably not the best way to handle, but there is a delay here
        // from when the center point is set on the map (inside the API call) in
        // which its showing the previous search result lat/lon. Maps above with
        // one or more locations results are properly handled with the setMapBounds
        // above
        //
        // we force a re-set of the center using the explicit coordinates from the api request
        mapRef.current.setCenter({
          lat: parseFloat(geocoordinates.lat),
          lng: parseFloat(geocoordinates.lon),
        });
        panToCenter();
      }
    }
  };

  // Google Map React Support functions
  // Function used as part of Google Map React's initialization process.
  const handleMapsApiLoaded = (map, maps) => {
    // Initialize map by assigning loaded google map to a ref object
    onMapLoad(map, maps);
    if (locations.length) {
      handleAutoZoom(locations);
    }
    const latitude = props.config.defaultLocation ? props.config.defaultLocation.lat : mapDefaults.latitude;
    const longitude = props.config.defaultLocation ? props.config.defaultLocation.lon : mapDefaults.longitude;
    /* initalize one infoWindow assigned/reused for the map */
    // Info window  elements requires unique id due to the possibility of multiple windows.
    infoWindowRef.current = new mapsRef.current.InfoWindow({
      ariaLabel: 'Location details',
      content: `<div id="infoWindow-${props.config.mapId}" />`,
      position: {
        lat: latitude,
        lng: longitude,
      },
      pixelOffset: new mapsRef.current.Size(0, -25),
    });
    // If multiple elements using Google Map are on the page this lets multiple instances load without erroring.
    window.dispatchEvent(new CustomEvent('googleMapApiLoaded', {}));
  };

  const handleMarkerClick = (id) => {
    let listedLocation;
    for (let i = 0; i < locations.length; i++) {
      if (parseInt(locations[i].id, 10) === parseInt(id, 10)
        || ((id === 0 || id === 1) && parseInt(locations[i].id, 10) === parseInt(selectedLocationId, 10))) {
        listedLocation = locations[i];
        break;
      } 
    }
    if (listedLocation) {
      if (id !== 0 && id !== 1) {
        setSelectedLocationId(id.toString());
      }
      setCenterPosition({
        centerLatitude: listedLocation.lat,
        centerLongitude: listedLocation.lon,
      });
    }
    toggleDisplayInfoWindow();
  };

  const handleBoundsChange = () => {
    filterLocations();
  };

  const addListenersOnPolygon = (polygon) => {
    //  == is used because somewhere the id numbers is turned into a string
    // then on successive clicks it becomes a number again
    mapsRef.current.event.addListener(polygon, 'click', (event) => {
      setSelectedLocationId(polygon.location.id.toString());
      createInfoWindow(polygon.location);
    });
    const defaultPolygon = props.config.serviceAreaGeojsonOptions.default
    || {
      strokeColor: '#000000',
      fillColor: '#000000',
      strokeOpacity: 0.4,
      strokeWeight: 1,
      fillOpacity: 0.1,
    };
    mapsRef.current.event.addListener(polygon, 'mouseout', (event) => {
      if (polygon.location.id != selectedLocationId) {
        polygon.setOptions({
          strokeColor: defaultPolygon.strokeColor,
          strokeOpacity: defaultPolygon.strokeOpacity,
          strokeWeight: defaultPolygon.strokeWeight,
          fillColor: defaultPolygon.fillColor,
          fillOpacity: defaultPolygon.fillOpacity,
        });
      }
    });
    const hoverPolygon = props.config.serviceAreaGeojsonOptions.hover
    || {
      strokeColor: '#000000',
      strokeOpacity: 0.7,
      strokeWeight: 1,
      fillColor: '#000000',
      fillOpacity: 0.3,
    };
    mapsRef.current.event.addListener(polygon, 'mouseover', (event) => {
      if (polygon.location.id != selectedLocationId) {
        polygon.setOptions({
          strokeColor: hoverPolygon.strokeColor,
          strokeOpacity: hoverPolygon.strokeOpacity,
          strokeWeight: hoverPolygon.strokeWeight,
          fillColor: hoverPolygon.fillColor,
          fillOpacity: hoverPolygon.fillOpacity,
        });
      }
    }); 
  };

  const handleMarkerKeyPress = (event, id) => {
    if (event.key === 'Enter') {
      handleMarkerClick(id);
    }
  };

  // Google Map Api query functions, run when the userLocation or filter states are changed
  const buildURLParams = () => {
    let urlParams = '';
    if (userLocation.userLocationString) {
      urlParams = `near_location=${userLocation.userLocationString}`;
    } else if (props.config.nearLocation && !initApiCallExecuted) {
      urlParams = `near_location=${props.config.nearLocation}`;
    } else if (userLocation.userLatitude && userLocation.userLongitude) {
      urlParams = `near_lat=${userLocation.userLatitude}`;
      urlParams += `&near_lon=${userLocation.userLongitude}`;
    }

    if (props.config.geocoderRegion) {
      urlParams += `&geocoder_region=${props.config.geocoderRegion}`;
    }
    if (props.config.geocoderComponents) {
      urlParams += `&geocoder_components=${props.config.geocoderComponents}`;
    }
    if (props.config.relevancyFilter) {
      urlParams += `&relevancy_filter=${props.config.relevancyFilter}`;
    }
    urlParams += `&distance_unit=${props.config.distanceUnit || 'miles'}`;
    urlParams += `&limit=${200}`;
    if (servicesFilters && servicesFilters.length > 0) {
      urlParams += '&services__in=';
      const services = servicesFilters;
      const len = services.length;
      for (let i = 0; i < len; i++) {
        urlParams += `${services[i]}`;
        if (i !== len - 1) {
          // api hates commas
          urlParams += ',';
        }
      }
    }
    // if postSearchFilters exist and servicesFilters have been chosen
    // otherwise this will create an error
    if (props.config.postSearchFilters && servicesFilters.length) {
      urlParams += '&post_search_filters=';
      for (let i = 0; i < props.config.postSearchFilters.length; i++) {
        urlParams += `${props.config.postSearchFilters[i]}`;
        if (i !== props.config.postSearchFilters.length - 1) {
          // api hates commas
          urlParams += ',';
        }
      }
    }
    if (props.config.languageCode) {
      // pass the current language code to the endpoint
      // this is needed for any hours-based translations
      urlParams += `&language_code=${props.config.languageCode}`;
    }
    if (props.config.publishedLocations === true) {
      // show only published locations
      urlParams += '&published=1';
    }
    if (props.config.enablePostalPrefixSearch === true) {
      // use postal_code prefix searching (canada postal codes)
      urlParams += '&prefix=true';
    }
    // if businessId is passed as a config option, then pass that
    if (props.config.businessId) {
      urlParams += `&business_id=${props.config.businessId}`;
    } else {
      urlParams += '&within_business=true';
    }
    return urlParams;
  };

  const loadServiceAreas = () => {
    const queryUrl = `${props.config.apiBaseUrl || '/'}modules/multilocation_service_areas/?limit=1000`;
    axios.get(queryUrl).then((response) => {
      const newServiceAreas = {};
      response.data.objects.forEach((obj) => {
        newServiceAreas[obj.id] = obj.service_areas_geojson;
      });
      setServiceAreas(newServiceAreas);
    });
  }

  const buildQueryUrl = () => {
    // Live site or local host
    const urlParams = buildURLParams();
    const baseUrl = `${props.config.apiBaseUrl || '/'}modules/multilocation/?`;
    return `${baseUrl}${urlParams}`;
  };

  const sendCustomEvent = (locationsLength, responseStatus, nearestResultDistance, nearestResultId) => {
    // Send event to the dataLayer
    window.dataLayer = window.dataLayer || [];

    // Determine the type of search that was performed
    let searchType = null;
    if (userLocation.userLocationString && userLocation.userLocationString == props.config.nearLocation) {
      // The user has entered a location via url parameter (other page)
      searchType = 'url_parameter';
    } else if (
      props.config.defaultLocation
      && userLocation.userLatitude && userLocation.userLongitude
      && props.config.defaultLocation.lat == userLocation.userLatitude
      && props.config.defaultLocation.lon == userLocation.userLongitude
    ) {
      // No geolocation was used, but a default location was set
      searchType = 'default_search';
    } else if (userLocation.userLatitude && userLocation.userLongitude) {
      // The user has used browser geolocation to search
      searchType = 'geolocation';
    } else if (userLocation.userLocationString) {
      // The user has entered a location search manually
      searchType = 'manual_search';
    }

    const dataLayerPayload = {
      event: 'locationfinder-search',
      event_action: 'search',
      event_category: 'locationfinder',
      nearest_result_distance: nearestResultDistance,
      nearest_result_id: nearestResultId,
      search_type: searchType,
      filters: servicesFilters,
      query: userLocation.userLocationString,
      num_results: locationsLength,
      status: responseStatus,
    };
    console.log('dataLayerPayload', dataLayerPayload);
    window.dataLayer.push(dataLayerPayload);
  };

  const getLocations = () => {
    // https://stackoverflow.com/questions/6092400/is-there-a-way-to-check-if-geolocation-has-been-declined-with-javascript
    if (selectedLocationId) {
      setSelectedLocationId(null);
    }
    /* reset the map to a "loading state" as we wait for results */
    if (!status.loading) {
      setStatus({ loading: true });
    }
    if ((userLocation.userLatitude && userLocation.userLongitude)
      || userLocation.userLocationString) {
      const queryUrl = buildQueryUrl();
      axios.get(queryUrl)
        .then((response) => {
          // redirectOneResult option which redirects the visitor if a single result
          // with a location_url is returned from a search
          if (props.config.redirectOneResult && (response.data.objects.length === 1) && response.data.objects[0].location_url) {
            window.location = response.data.objects[0].location_url;
          }
          setStatus({ error: false, loading: false });
          setLocations(response.data.objects);
          if (props.config.infoWindowOnSearch
            && mobileDetect.props.getBreakpoint() !== 'sm'
            && response.data.objects.length > 0
            && (((response.data.objects[0].distance < parseFloat(props.config.initialSearchThreshold)) && !initApiCallExecuted) || response.data.objects[0].distance < parseFloat(props.config.threshold))) {
            setSelectedLocationId(response.data.objects[0].id.toString());
          }
          setCenterPosition({
            centerLatitude: parseFloat(response.data.meta.lat),
            centerLongitude: parseFloat(response.data.meta.lon),
          });
          if (mapRef.current && mapsRef.current) {
            handleAutoZoom(response.data.objects, response.data.meta);
          }
          if (response.data.meta && typeof response.data.meta.matches_filters_count === 'number') {
            setMatchesFilterCount(response.data.meta.matches_filters_count);
          }
          // send custom event to dataLayer
          sendCustomEvent(
            response.data.objects.length,
            response.status,
            response.data.objects.length > 0 ? response.data.objects[0].distance : null,
            response.data.objects.length > 0 ? response.data.objects[0].id : null,
          );
        })
        .catch((err) => {
          // send custom event to dataLayer
          sendCustomEvent(null, err.response.status, null, null);
          setStatus({ error: true, loading: false });
        });
      displayInfoWindow = false;
      initApiCallExecuted = true;
    }
  };

  // Self terminating event listener helper function used by render logic.
  const secondaryMap = () => {
    // Other module has finished loading the google map api and triggered callback function which triggers the event listener.
    window.removeEventListener('googleMapApiLoaded', secondaryMap, true);
    // Triggers state change which causes maps after the first to re-render and display a map.
    // Do not trust linter.
    setDelayedLoad(true);
  };

  // Effects
  // On intial load set starting location
  // repeats checks because of allow access options
  // Issue - this seems to cause a screen jump
  useEffect(() => {
    if ((props.config.nearLocation 
      || (props.config.defaultLocation && props.config.searchOnLoad))
      && !initApiCallExecuted
    ) {
      const interval = setInterval(() => {
        // does not have an error condition
        // throughout the module it is assumed the google map api will be reached
        if (window.google && window.google.maps) {
          setStartingLocation();
          clearInterval(interval);
        }
      }, 100);
    } else {
      const interval = setInterval(() => {       
        navigator.geolocation.watchPosition((position) => {
          setStartingLocation();
        },
        (error) => {
          if (error.code == error.PERMISSION_DENIED) {
            setLocationStatus('error');
            setStatus({ error: true, loading: false });
          }
        });
        clearInterval(interval);
      }, 1000);
    }
  }, []);

  // On initial load, set the service_areas
  useEffect(() => {
    if (props.config.enableServiceAreaGeojson) {
      loadServiceAreas();
    }
  }, []);

  // When filters are selected or a search is conducted get locations
  useEffect(() => {
    if (servicesFilters.length === 0) {
      setMatchesFilterCount(false);
    }
    // Close current infoWindow if present
    if (infoWindowRef.current) {
      infoWindowRef.current.close(mapRef.current);
    }
    displayInfoWindow = false;
    userInteractionToggle = false;
    getLocations();
  }, [distanceFilter, servicesFilters, userLocation]);

  const generateMarkers = () => {
    const markers = locations.map((location) => {
      let isActive = false;
      if (selectedLocationId
        && (parseInt(location.id, 10) === parseInt(selectedLocationId, 10))) {
        // currently selected location
        isActive = true;
        // should we pop open the infowindow
        if (mobileDetect.props.getBreakpoint() !== 'sm'
          && displayInfoWindow) {
          createInfoWindow(location);
        }
      }

      return <Marker
        key={location.id}
        type="pin"
        lat={location.lat}
        lng={location.lon}
        location={location}
        handleMarkerKeyPress={handleMarkerKeyPress}
        selected={isActive}
        servicesTags={location.services_tags}
      />;
    });
    setLocationMarkers(markers);
  };

  // When location changes adjust map zoom and create new location markers for map
  useEffect(() => {
    // Generate markers
    if (locations.length > 0) {
      generateMarkers();
      filterLocations();
    } else {
      setLocationMarkers();
      setDisplayedLocations([]);
      if (infoWindowRef.current) {
        infoWindowRef.current.close(mapRef.current);
      }
    }
  }, [locations]);

  useEffect(() => {
    // Technically all this does is change which marker is marked as isActive
    // There might be a more performative way to do this that regenerate all markers
    generateMarkers();
  }, [selectedLocationId]);

  useEffect(() => {
    if (mapRef.current) {
      centerMap();
    }
  }, [centerPosition]);

  // Scroll to selected location after displayed list is updated
  useEffect(() => {
    if (selectedLocationId) {
      // Use setTimeout to ensure DOM has updated after displayedLocations change
      const scrollTimer = setTimeout(() => {
        const selectedLocation = document.getElementById(`location-${selectedLocationId}`);
        // Pins will render even when geolocation blocking prevents rendering of a locations list
        if (selectedLocation) {
          selectedLocation.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }, 0);
      return () => clearTimeout(scrollTimer);
    }
    return undefined;
  }, [selectedLocationId, displayedLocations]);

  // Conditional code that runs on every state change below:
  // are service areas used? are there locations? has google map initiated yet?
  // Generate polygons
  if (props.config.enableServiceAreaGeojson && locations && mapRef.current) {
    // polygon objects are part of the google map object
    // they are not automatically refreshed on render 
    // therefore they must be removed manually
    for (let i = polygons.length - 1; i >= 0; i--) {
      polygons[i].setMap(null);
      polygons.pop();
    }
    const defaultPolygon = props.config.serviceAreaGeojsonOptions.default
    || {
      strokeColor: '#000000',
      fillColor: '#000000',
      strokeOpacity: 0.4,
      strokeWeight: 1,
      fillOpacity: 0.1,
    };
    const selectedPolygon = props.config.serviceAreaGeojsonOptions.selected
    || {
      strokeColor: '#1F618D',
      fillColor: '#1F618D',
      strokeOpacity: 0.7,
      strokeWeight: 2,
      fillOpacity: 0.3,
    };
    locations.map((location) => {
      const serviceAreasGeojson = serviceAreas[location.id];
      if (serviceAreasGeojson && serviceAreasGeojson.features && mapsRef.current && mapRef.current) {
        for (const feature of serviceAreasGeojson.features) {
          const coordinates = feature.geometry.coordinates[0].map(([lng, lat]) => ({ lng, lat }));
          //  == is used because somewhere the id numbers is turned into a string
          // then on successive clicks it becomes a number again
          const polygon = new mapsRef.current.Polygon({
            paths: coordinates,
            strokeColor: (selectedLocationId == location.id ? selectedPolygon.strokeColor : defaultPolygon.strokeColor),
            strokeOpacity: (selectedLocationId == location.id ? selectedPolygon.strokeOpacity : defaultPolygon.strokeOpacity),
            strokeWeight: (selectedLocationId == location.id ? selectedPolygon.strokeWeight : defaultPolygon.strokeWeight),
            fillColor: (selectedLocationId == location.id ? selectedPolygon.fillColor : defaultPolygon.fillColor),
            fillOpacity: (selectedLocationId == location.id ? selectedPolygon.fillOpacity : defaultPolygon.fillOpacity),
            location: location,
          });
          polygons.push(polygon);
          polygons[polygons.length - 1].setMap(mapRef.current);
          addListenersOnPolygon(polygon);
        }
      }
    });
  }

  // Map Loading place holder
  if (status.loading) {
    LoadingMap = <div className="sb-map-loading"></div>;
  } else if (status.error) {
    LoadingMap = <div className="invalid-request"></div>;
  }

  // User location marker
  if (props.userLocation) {
    UserLocationMarker = <Marker
      type="currentlocation"
      lat={userLocation.userLatitude}
      lng={userLocation.userLongitude}
    />;
  }

  // https://github.com/devhub/dhplatform/issues/10618
  // centerPosition.centerLatitude !== mapDefaults.latitude prevents marker appearing for default center
  // When a new center value is received it will display even if center location is similar to default
  // The default is set to a whole integer, googleMap API returns values of much higher float specifity.
  // Therefore a latitude value returned from the googleMap API will always update the center value by default
  // so long as you check against a string. 
  // Conversion toString() handles the specific edge case of a user standing on the precise latitudinal axis
  const defaultMapOptions = {
    fullscreenControl: false,
    keyboardShortcuts: false,
  };

  if (props.config.googleMapStyleConfig) {
    defaultMapOptions.styles = props.config.googleMapStyleConfig;
  }

  // prevents undefined error is default location is not set or null
  const defaultLocationLatitude = props.config.defaultLocation ? props.config.defaultLocation.lat : null;

  const googleMapReactComponent = (
    <GoogleMapReact
      bootstrapURLKeys={{ key: googleApiKey, language: props.config.language }}
      zoom={mapZoom}
      defaultCenter={{ lat: mapDefaults.latitude, lng: mapDefaults.longitude }}
      yesIWantToUseGoogleMapApiInternals
      options={defaultMapOptions}
      onGoogleApiLoaded={({ map, maps }) => handleMapsApiLoaded(map, maps)}
      onBoundsChange={handleBoundsChange}
      onChildClick={handleMarkerClick}
    >
      { centerPosition.centerLatitude.toString() !== mapDefaults.latitude.toString()
        && centerPosition.centerLatitude !== defaultLocationLatitude
        && <CurrentPositionMarker
            lat={centerPosition.centerLatitude}
            lng={centerPosition.centerLongitude}
          />
      }
      {UserLocationMarker}
      {locationMarkers}
    </GoogleMapReact>
  );

  // Render logic and control
  // GoogleMapReact package will check if Google Map API exists and not start a new initialization
  // However just because the Google Map API has been initialized does not mean it has finished loading.
  // This will throw cause a maps undefined error.
  if (!window.sbGoogleMapInitiated) {
    // Due to the way our module system operates there is no centralized javascript control system for modules
    // Therefore a window property is set to communicate with other modules
    // If google maps isn't loaded proceed as normal and set flag on window.
    // This flag prevents other DevHub Google Map modules from starting before google maps api has loaded.
    // Note: Google Map module only refers to modules that use this React code
    // Client code that initilizes the google map API after this code runs will cause an initialization error.
    // Client code that initilizes the google map API but fails to complete the process before this code runs will cause a maps undefined error
    // 11/3/2020 DevHub Location finder will have same issues as client code if on same page.
    DisplayMap = googleMapReactComponent;
    window.sbGoogleMapInitiated = true;
  } else if (window.google && window.google.maps) {
    // Allows component to render if google maps object exist.
    // There is a possibility the google maps api may not be fully loaded when these objects are present.
    // This means there is a small chance of errors firing.
    DisplayMap = googleMapReactComponent;
  } else {
    // Google map API is being initiated by another Google Map module listen for when it finishes.
    // Other methods do exist to accomplish the same task.
    // ES5 methods are erractic in implementation and poorly implemented.
    // ES6 Proxy getters and setters would be a sounder solution but it can not be shimmed.
    window.addEventListener('googleMapApiLoaded', secondaryMap, true);
  }

  return (
    <div
      className="sb-locationfinder"
      role="region"
      id="Google-Map-Location-Finder"
      aria-label={i18n.t('screenReaderIntro')}
    >
      {LoadingMap}
      <CtaBlock
        customTemplates={props.config.customTemplates}
        disableGeolocation={props.config.disableGeolocation}
        distanceFilter={distanceFilter}
        error={status.error}
        filtersLayout={props.config.filtersLayout || 'panel'}
        filters={props.config.filters}
        loadingStatus={status.loading}
        locations={displayedLocations}
        locationStatus={locationStatus}
        matchesFilterCount={matchesFilterCount}
        searchInputPlaceholderText={props.config.searchInputPlaceholderText}
        searchInputType={props.config.searchInputType}
        setCenterPosition={setCenterPosition}
        setLocationStatus={setLocationStatus}
        selectedLocationId={selectedLocationId}
        setSelectedLocationId={setSelectedLocationId}
        servicesFilters={servicesFilters}
        setServicesFilters={setServicesFilters}
        setUserLocation={setUserLocation}
        toggleDisplayInfoWindow={toggleDisplayInfoWindow}
        userLocation={userLocation}
      />
      <div className="sb-map-container" id="Google-Map-Container">
        {DisplayMap}
      </div>
      <div className="sb-map-bounds" style={{ display: 'none' }}></div>
      {mobileDetect}
    </div>
  );
};

Map.propTypes = {
  config: PropTypes.object,
  redirectOneResult: PropTypes.bool,
  userLocation: PropTypes.object,
};

export default Map;
